<script lang="ts" setup>
import AccountSettingsAccount from '@/views/pages/account-settings/AccountSettingsAccount.vue'
import AccountSettingsSecurity from '@/views/pages/account-settings/AccountSettingsSecurity.vue'
import AccountSettingsStatistics from '@/views/pages/account-settings/AccountSettingsStatistics.vue'

const route = useRoute('account-settings-tab')
const { t } = useI18n()

const activeTab = computed({
  get: () => route.params.tab,
  set: () => route.params.tab,
})

// tabs
const tabs = [
  { title: 'account', icon: 'tabler-users', tab: 'account' },
  { title: 'security', icon: 'tabler-lock', tab: 'security' },
  { title: 'statistics', icon: 'tabler-chart-bar', tab: 'statistics' },
]

definePage({
  meta: {
    navActiveLink: 'account-settings-tab',
    action: 'manage',
    subject: 'profile',
  },
})
</script>

<template>
  <div>
    <VTabs
      v-model="activeTab"
      class="v-tabs-pill"
    >
      <VTab
        v-for="item in tabs"
        :key="item.icon"
        :value="item.tab"
        :to="{ name: 'account-settings-tab', params: { tab: item.tab } }"
      >
        <VIcon
          size="20"
          start
          :icon="item.icon"
        />
        {{ t(`profile.${item.title}`) }}
      </VTab>
    </VTabs>

    <VWindow
      v-model="activeTab"
      class="mt-6 disable-tab-transition"
      :touch="false"
    >
      <!-- Account -->
      <VWindowItem value="account">
        <AccountSettingsAccount />
      </VWindowItem>

      <!-- Security -->
      <VWindowItem value="security">
        <AccountSettingsSecurity />
      </VWindowItem>
      <!-- Security -->
      <VWindowItem value="statistics">
        <AccountSettingsStatistics />
      </VWindowItem>
    </VWindow>
  </div>
</template>
